import { render, staticRenderFns } from "./Cumulative.vue?vue&type=template&id=492808f5&"
import script from "./Cumulative.vue?vue&type=script&lang=js&"
export * from "./Cumulative.vue?vue&type=script&lang=js&"
import style0 from "./Cumulative.vue?vue&type=style&index=0&id=492808f5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports